<h1 class="text-center mt-5">{{ 'GENERIC.COMMON_PAGES.PAGE_NOT_FOUND_TEXT' | translate }}</h1>